module.exports = __webpack_public_path__ + "static/media/weibo.232a1478.png";